import { render, staticRenderFns } from "./CustomSzwtProcessList.vue?vue&type=template&id=b9c6cda4&scoped=true&"
import script from "./CustomSzwtProcessList.vue?vue&type=script&lang=js&"
export * from "./CustomSzwtProcessList.vue?vue&type=script&lang=js&"
import style0 from "./CustomSzwtProcessList.vue?vue&type=style&index=0&id=b9c6cda4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c6cda4",
  null
  
)

export default component.exports